const mapTermsPage = (data) => {
  const { subtitle, text, title } = data;
  return {
    subtitle,
    text,
    title
  };
};

export default mapTermsPage;
